import { jsxs as O, jsx as f } from "react/jsx-runtime";
import { I as j } from "./ic_arrowmore_fill-BlVN5kGZ.mjs";
import { createContext as Y, useContext as ee, useState as P, useMemo as F, useEffect as E, useRef as D, useCallback as I, forwardRef as R, isValidElement as te, cloneElement as re } from "react";
import { e as H } from "./extract-responsive-property-BiJ5BiwI.mjs";
import { c as S } from "./tw-cn-mXgPecoF.mjs";
import { c as x } from "./variance-DhhqoHkK.mjs";
import { o as U } from "./index-CcECYkhV.mjs";
import { I as ne } from "./ic_arrowless_fill-DCwkJEfT.mjs";
const ae = x(["relative w-full bg-static-white select-none"]), le = x(
  [
    "relative flex w-full min-h-32 py-4 px-16 items-center cursor-pointer !truncate",
    "border border-line-neutral-weak3 overflow-hidden rounded-8",
    "bg-static-white text-text-neutral-main placeholder:text-text-neutral-main",
    "hover-never:bg-interaction-neutral-presshover-weak1 active:bg-interaction-neutral-presshover-weak1",
    "disabled:bg-fill-neutral-weak disabled:cursor-not-allowed",
    "disabled:text-interaction-neutral-disable-main disabled:hover-never:bg-fill-neutral-weak",
    "disabled:placeholder:text-interaction-neutral-disable-main disabled:hover-never:place-holder:bg-fill-neutral-weak"
  ],
  {
    variants: {
      open: {
        true: "rounded-b-none border-b-0",
        false: ""
      },
      selected: {
        true: "!font-bold text-text-neutral-main",
        false: "text-text-neutral-sub"
      },
      size: {
        small: "h-32 typography-body-12-regular pr-36",
        medium: "h-44 typography-subtitle-16-regular pr-40",
        large: "h-56 typography-subtitle-18-regular pr-44"
      },
      pcSize: {
        small: "pc:h-32 pc:typography-body-12-regular pc:pr-36",
        medium: "pc:h-44 pc:typography-subtitle-16-regular pc:pr-40",
        large: "pc:h-56 pc:typography-subtitle-18-regular pc:pr-44"
      }
    }
  }
), oe = x("placeholder:text-text-neutral-sub", {
  variants: {
    size: {
      small: "",
      medium: "rounded-12",
      large: "rounded-16"
    },
    pcSize: {
      small: "",
      medium: "pc:rounded-12",
      large: "pc:rounded-16"
    },
    hasLeadingElement: {
      true: "pl-40",
      false: ""
    },
    hasError: {
      true: "border-line-danger-main",
      false: ""
    },
    selected: {
      true: "!font-normal",
      false: ""
    }
  },
  compoundVariants: [
    {
      hasLeadingElement: !0,
      size: "small",
      class: "pl-40"
    },
    {
      hasLeadingElement: !0,
      size: "medium",
      class: "pl-44"
    },
    {
      hasLeadingElement: !0,
      size: "large",
      class: "pl-48"
    }
  ]
}), se = x(
  [
    "absolute right-16 top-1/2 size-16 -translate-y-1/2 pointer-events-none",
    "aria-disabled:text-interaction-neutral-disable-main"
  ],
  {
    variants: {
      open: {
        true: "rotate-180",
        false: ""
      },
      size: {
        small: "size-16",
        medium: "size-20",
        large: "size-24"
      },
      pcSize: {
        small: "pc:size-16",
        medium: "pc:size-20",
        large: "pc:size-24"
      },
      disabled: {
        true: "hidden",
        false: ""
      }
    }
  }
), ie = x("absolute left-16 top-1/2 -translate-y-1/2", {
  variants: {
    disabled: {
      true: "opacity-20",
      false: ""
    }
  }
}), de = x("mt-8 px-4 text-text-neutral-main typography-body-12-regular", {
  variants: {
    hasError: {
      true: "text-text-danger-main",
      false: ""
    },
    disabled: {
      true: "text-interaction-neutral-disable-main",
      false: ""
    }
  }
}), _ = (r) => {
  const {
    value: a,
    size: s,
    className: i,
    label: e,
    supportText: l,
    optionalText: o,
    id: t,
    leadingElement: c,
    hasError: u = !1,
    ...d
  } = r, n = H({
    property: s,
    mobileKey: "size",
    pcKey: "pcSize",
    defaultValue: { mobile: "small", pc: "medium" }
  }), b = ae(), v = le({ ...n, selected: !!a }), p = oe({
    ...n,
    hasLeadingElement: !!c,
    hasError: u,
    selected: !!a
  }), g = se({ ...n, disabled: d.disabled }), N = ie({
    disabled: d.disabled
  }), C = de({
    ...n,
    hasError: u,
    disabled: d.disabled
  });
  return /* @__PURE__ */ O("div", { className: S("relative", b, i), children: [
    e || o ? /* @__PURE__ */ O("label", { className: "mb-8 flex gap-2 px-4 text-text-neutral-main typography-body-13-semibold", htmlFor: t, children: [
      e,
      o ? /* @__PURE__ */ f("span", { className: "text-text-neutral-sub typography-body-13-regular", children: o }) : null
    ] }) : null,
    /* @__PURE__ */ O("div", { className: "relative", children: [
      /* @__PURE__ */ f(
        "input",
        {
          id: t,
          ...d,
          className: S(v, p),
          readOnly: !0,
          value: a
        }
      ),
      c ? /* @__PURE__ */ f("div", { className: S(N), children: c }) : null,
      /* @__PURE__ */ f(j, { "aria-disabled": d.disabled, className: g })
    ] }),
    l ? /* @__PURE__ */ f("p", { className: S(C), children: l }) : null
  ] });
};
_.displayName = "NDS.SelectboxButton";
const q = Y(null);
function A() {
  const r = ee(q);
  if (r === null)
    throw new Error("useSelectContext must be used within a SelectProvider");
  return r;
}
function ce({ open: r, value: a, size: s, onChangeValue: i, onChangeOpen: e, children: l }) {
  const [o, t] = P({
    value: a,
    candidateOption: null,
    options: /* @__PURE__ */ new Map()
  }), c = H({
    property: s,
    mobileKey: "size",
    pcKey: "pcSize",
    defaultValue: { mobile: "small", pc: "medium" }
  }), u = F(
    () => ({
      onChangeOpen: e,
      onChangeValue: i,
      setOption(n, b) {
        t((v) => {
          const { options: p } = v, g = new Map(p);
          return g.set(n, { value: b }), { ...v, options: g };
        });
      },
      setCandidateOption(n) {
        t((b) => ({ ...b, candidateOption: n }));
      }
    }),
    [e, i]
  ), d = F(
    () => ({ ...o, open: !!r, ...c, ...u }),
    [o, r, u]
  );
  return E(() => {
    t((n) => ({ ...n, value: a, isOpen: !1 }));
  }, [a]), E(() => {
    r || t((n) => ({
      ...n,
      options: /* @__PURE__ */ new Map(),
      candidateOption: null
    }));
  }, [r]), /* @__PURE__ */ f(q.Provider, { value: d, children: l });
}
const ue = x(["relative w-full bg-static-white select-none"]), pe = x(
  [
    "relative flex w-full min-h-32 py-4 px-16 items-center cursor-pointer !truncate",
    "border border-line-neutral-weak3 overflow-hidden rounded-8",
    "bg-static-white text-text-neutral-main placeholder:text-text-neutral-main",
    "hover-never:bg-interaction-neutral-presshover-weak1 active:bg-interaction-neutral-presshover-weak1",
    "disabled:bg-fill-neutral-weak disabled:cursor-not-allowed",
    "disabled:text-interaction-neutral-disable-main disabled:hover-never:bg-fill-neutral-weak",
    "disabled:placeholder:text-interaction-neutral-disable-main disabled:hover-never:place-holder:bg-fill-neutral-weak"
  ],
  {
    variants: {
      open: {
        true: "rounded-b-none border-b-0",
        false: ""
      },
      selected: {
        true: "!font-bold text-text-neutral-main",
        false: "text-text-neutral-sub"
      },
      size: {
        small: "h-32 typography-body-12-regular pr-36",
        medium: "h-44 typography-subtitle-16-regular pr-40"
      },
      pcSize: {
        small: "pc:h-32 pc:typography-body-12-regular pc:pr-36",
        medium: "pc:h-44 pc:typography-subtitle-16-regular pc:pr-40"
      }
    }
  }
), be = x(
  [
    "absolute right-16 top-1/2 size-16 -translate-y-1/2 pointer-events-none",
    "aria-disabled:text-interaction-neutral-disable-main"
  ],
  {
    variants: {
      open: {
        true: "rotate-180",
        false: ""
      },
      size: {
        small: "size-16",
        medium: "size-20"
      },
      pcSize: {
        small: "pc:size-16",
        medium: "pc:size-20"
      },
      disabled: {
        true: "hidden",
        false: ""
      }
    }
  }
), me = x(
  ["absolute w-full rounded-b-8 border border-line-neutral-weak3 bg-static-white", "absolute border-t-0 "],
  {
    variants: {
      size: {
        small: "top-32",
        medium: "top-44"
      },
      pcSize: {
        small: "pc:top-32",
        medium: "pc:top-44"
      }
    }
  }
), fe = x(
  ["flex py-4 px-20 items-center cursor-pointer", "hover:bg-interaction-neutral-presshover-weak1"],
  {
    variants: {
      size: {
        small: "min-h-32 typography-body-12-regular",
        medium: "min-h-44 typography-subtitle-16-regular"
      },
      pcSize: {
        small: "pc:min-h-32 pc:typography-body-12-regular",
        medium: "pc:min-h-44 pc:typography-subtitle-16-regular"
      }
    }
  }
), K = ({ value: r, className: a, isCustom: s = !1, children: i }) => {
  const e = D(null), {
    value: l,
    candidateOption: o,
    setCandidateOption: t,
    size: c,
    pcSize: u,
    setOption: d,
    onChangeValue: n,
    onChangeOpen: b
  } = A(), v = fe({ size: c, pcSize: u }), p = l === r, g = o === e.current;
  E(() => {
    const m = e.current;
    d(m, r);
  }, [r, d]);
  const N = I(() => {
    n(r), b(!1);
  }, [r, n, b]), C = I(() => {
    const m = e.current;
    t(m);
  }, [t]);
  return /* @__PURE__ */ f(
    "li",
    {
      "aria-selected": p,
      className: s ? a : S(
        v,
        { "bg-interaction-neutral-presshover-weak1 !font-bold": p },
        { "bg-interaction-neutral-presshover-weak1": g },
        a
      ),
      onClick: N,
      onMouseEnter: C,
      ref: e,
      role: "option",
      tabIndex: -1,
      children: i
    }
  );
};
K.displayName = "NDS.DropdownOption";
const Z = R(({ className: r, style: a, children: s }, i) => {
  const { open: e, size: l, pcSize: o } = A(), t = me({ size: l, pcSize: o });
  return e ? /* @__PURE__ */ f("ul", { className: S(t, r), ref: i, style: a, children: s }) : null;
});
Z.displayName = "NDS.DropdownOptions";
const $ = R((r, a) => {
  const { onClick: s, onKeyDown: i, ...e } = r, l = D(null), { value: o, options: t, candidateOption: c, open: u, size: d, pcSize: n, setCandidateOption: b, onChangeValue: v, onChangeOpen: p } = A(), g = pe({ size: d, pcSize: n, open: u, selected: !!o }), N = be({ size: d, pcSize: n, open: u, disabled: e.disabled }), C = I(
    (y) => {
      p(!u), s == null || s(y);
    },
    [s, p, u]
  ), m = I(
    (y) => {
      if (y.preventDefault(), t.size === 0) return;
      const T = (w) => [...t].findIndex(([k]) => k === w);
      if (u)
        switch (y.code) {
          case "ArrowUp": {
            const w = T(c);
            if (w !== -1) {
              const h = (w - 1 + t.size) % t.size, k = [...t.keys()][h];
              b(k);
            } else {
              const h = [...t.keys()][0];
              b(h);
            }
            break;
          }
          case "ArrowDown": {
            const w = T(c);
            if (w !== -1) {
              const h = (w + 1) % t.size, k = [...t.keys()][h];
              b(k);
            } else {
              const h = [...t.keys()][0];
              b(h);
            }
            break;
          }
          case "Enter": {
            if (c === null) break;
            const { value: w } = t.get(c);
            v(w), p(!1);
            break;
          }
          case "Escape":
          case "Tab": {
            p(!1);
            break;
          }
        }
      else
        switch (y.code) {
          case "Enter":
          case "ArrowDown": {
            p(!0);
            break;
          }
        }
      i == null || i(y);
    },
    [t, c, u, b, i, v, p]
  );
  return /* @__PURE__ */ O("div", { className: "relative", children: [
    /* @__PURE__ */ f(
      "input",
      {
        ...e,
        className: g,
        onClick: C,
        onFocus: () => {
          var y;
          return (y = l.current) == null ? void 0 : y.blur();
        },
        onKeyDown: m,
        readOnly: !0,
        ref: U([l, a])
      }
    ),
    /* @__PURE__ */ f(j, { "aria-disabled": e.disabled, className: N })
  ] });
});
$.displayName = "NDS.DropdownTrigger";
const G = R(({ children: r, className: a }, s) => {
  const i = D(null), { open: e, onChangeOpen: l } = A(), o = ue();
  return E(() => {
    if (!e) return;
    const t = i.current, c = (u) => {
      const d = u.target;
      t.contains(d) || l(!1);
    };
    return document.addEventListener("click", c), () => {
      document.removeEventListener("click", c);
    };
  }, [e, l]), /* @__PURE__ */ f("div", { className: S(o, a), ref: U([i, s]), children: r });
});
G.displayName = "DropdownWrapper";
const J = (r) => {
  const {
    id: a,
    name: s,
    placeholder: i,
    defaultValue: e,
    value: l,
    options: o,
    required: t,
    disabled: c,
    size: u,
    optionZIndex: d = 10,
    customOptions: n,
    onFocus: b,
    onBlur: v,
    onChange: p,
    children: g,
    className: N,
    optionClassName: C
  } = r, m = D(null), y = D(null), [T, w] = P(!1), [h, k] = P(""), V = (z) => {
    w(z);
  }, B = () => {
    w(!1);
  };
  E(() => {
    const z = m.current, L = l || z.value || e || z.defaultValue;
    k(L);
  }, [l, e]), E(() => {
    var M;
    const z = m.current;
    (M = Object.getOwnPropertyDescriptor(window.HTMLInputElement.prototype, "value").set) == null || M.call(z, h || "");
    const X = new Event("change", { bubbles: !0 });
    z.dispatchEvent(X), z.focus();
  }, [h]);
  const W = () => o ? o.map(({ value: z, label: L }) => /* @__PURE__ */ f(K, { value: z, children: L }, z)) : n ? ge(n, B) : typeof g == "function" ? g({ onClose: B }) : g;
  return /* @__PURE__ */ f(
    ce,
    {
      size: u,
      value: h,
      open: T,
      onChangeOpen: V,
      onChangeValue: k,
      children: /* @__PURE__ */ O(G, { className: N, ref: y, children: [
        /* @__PURE__ */ f(
          $,
          {
            disabled: c,
            id: a,
            name: s,
            onBlur: v,
            onChange: (z) => {
              p == null || p(z);
            },
            onFocus: b,
            placeholder: i,
            readOnly: !0,
            ref: m,
            required: t
          }
        ),
        /* @__PURE__ */ f(Z, { className: S("overflow-hidden", C), style: { zIndex: d }, children: W() })
      ] })
    }
  );
};
function ge(r, a) {
  return r ? r.map((s, i) => {
    if (!te(s)) return s;
    const e = s, l = e.props.onClick;
    return re(e, {
      onClick: (o) => {
        l == null || l(o), a();
      },
      key: e.key ?? i
    });
  }) : null;
}
J.displayName = "NDS.Dropdown";
const he = x(
  ["relative overflow-hidden", "border border-solid border-line-neutral-weak3", "rounded-b-8", "gap-4"],
  {
    variants: {
      isOpen: {
        true: "border-2 border-line-neutral-main border-t-0",
        false: ""
      }
    },
    defaultVariants: {
      isOpen: !1
    }
  }
), xe = x(["relative typography-subtitle-16-regular"], {
  variants: {
    isOpen: {
      true: "rounded-b-none",
      false: ""
    },
    disabled: {
      true: "!font-bold text-text-neutral-main",
      false: "text-text-neutral-sub"
    }
  }
}), ve = x(
  [
    "relative flex w-full min-h-44 py-4 px-16 items-center cursor-pointer",
    "border border-line-neutral-weak3 overflow-hidden rounded-8",
    "typography-subtitle-16-regular",
    "bg-static-white text-text-neutral-main placeholder:text-text-neutral-main",
    "hover-never:bg-interaction-neutral-presshover-weak1 active:bg-interaction-neutral-presshover-weak1",
    "text-left",
    "disabled:bg-fill-neutral-weak disabled:cursor-not-allowed disabled:active:bg-fill-neutral-weak disabled:active:cursor-not-allowed",
    "disabled:text-interaction-neutral-disable-main disabled:hover-never:bg-fill-neutral-weak",
    "disabled:placeholder:text-interaction-neutral-disable-main disabled:hover-never:place-holder:bg-fill-neutral-weak"
  ],
  {
    variants: {
      isAccent: {
        true: "border-2 border-line-neutral-main",
        false: ""
      },
      isOpen: {
        true: "rounded-b-none border-2 border-line-neutral-main border-b-0",
        false: "before:hidden"
      },
      disabled: {
        true: "cursor-not-allowed",
        false: ""
      },
      hasDivider: {
        true: "before:absolute before:bottom-0 before:left-0 before:h-1 before:w-full before:bg-fill-neutral-weak3",
        false: ""
      }
    },
    defaultVariants: {
      isOpen: !1
    }
  }
), ye = x(
  ["aria-disabled:text-interaction-neutral-disable-main", "ml-auto shrink-0", "size-20"],
  {
    variants: {
      isOpen: {
        true: "",
        false: "rotate-180"
      },
      disabled: {
        true: "hidden",
        false: ""
      }
    }
  }
), we = x(["mr-8 break-words"], {
  variants: {
    selected: {
      true: "text-text-neutral-main typography-subtitle-16-bold",
      false: "text-text-neutral-sub"
    },
    isAccent: {
      true: "",
      false: ""
    },
    disabled: {
      true: "cursor-not-allowed text-interaction-neutral-disable-main",
      false: ""
    },
    disabledAccent: {
      true: ["border-line-neutral-weak3 bg-fill-neutral-weak1", "text-text-neutral-sub typography-subtitle-16-bold"],
      false: ""
    }
  },
  defaultVariants: {
    //
  }
}), Q = R(
  ({
    value: r,
    isOpen: a,
    placeholder: s = "선택해 주세요",
    className: i,
    onClick: e,
    zIndex: l,
    isDisabled: o,
    isAccent: t,
    textClassName: c,
    needDisabledAccent: u,
    hasDivider: d
  }, n) => {
    const b = l ? `z-${l}` : "z-1", v = ve({
      isOpen: a,
      isAccent: t,
      disabled: o,
      hasDivider: d
    }), p = we({
      selected: !!r,
      disabled: o,
      isAccent: t,
      disabledAccent: u
    }), g = ye({ isOpen: a, disabled: o });
    return /* @__PURE__ */ O(
      "button",
      {
        "aria-expanded": a,
        "aria-haspopup": "listbox",
        className: S(v, i, b),
        disabled: o,
        onClick: e,
        ref: n,
        type: "button",
        children: [
          /* @__PURE__ */ f("span", { className: S(p, c), children: r || s }),
          /* @__PURE__ */ f(ne, { className: S(g) })
        ]
      }
    );
  }
);
Q.displayName = "PullDownTrigger";
const ke = ({
  children: r,
  value: a,
  isOpen: s,
  defaultOpen: i = !1,
  onOpenChange: e,
  placeholder: l = "선택해 주세요",
  triggerClassName: o,
  triggerContentClassName: t,
  contentClassName: c,
  wrapperClassName: u,
  disabled: d,
  isClosable: n = !1,
  isAccent: b = !1,
  needDisabledAccent: v,
  hasDivider: p
}) => {
  const [g, N] = P(i), C = s !== void 0, m = C ? s : g, y = D(null), T = xe({ isOpen: m, disabled: d }), w = he({ isOpen: m }), h = I(
    (k) => {
      d || !n && m || (C ? e == null || e(k) : N(k));
    },
    [m, e, d, n, C]
  );
  return E(() => {
    if (!m || !n) return;
    const k = y.current, V = (B) => {
      const W = B.target;
      k.contains(W) || h(!1);
    };
    return document.addEventListener("click", V), () => {
      document.removeEventListener("click", V);
    };
  }, [m, n, h]), /* @__PURE__ */ O("div", { className: S(T, u), ref: y, children: [
    /* @__PURE__ */ f(
      Q,
      {
        className: o,
        hasDivider: p,
        isAccent: b,
        isDisabled: d,
        isOpen: m,
        needDisabledAccent: v,
        onClick: () => {
          h(!m);
        },
        placeholder: l,
        textClassName: t,
        value: a
      }
    ),
    m ? /* @__PURE__ */ f("div", { className: S(w, c), children: r }) : null
  ] });
}, Ie = {
  Dropdown: J,
  DropdownOption: K,
  Button: _,
  PullDown: ke
};
export {
  Ie as Selectbox,
  _ as SelectboxButton
};
